<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
              <div class="table-responsive datatable-vue text-center">
                <b-modal :ref="'alertdelete'+site" title="Confirmation" @ok="onDelete()">
                  <p class="my-4">Are you sure to delete this Commande ? </p>
                </b-modal>
                <!-- Envoi de la commande au fournisseur dropshipping (BigBuy ou
                     EPROLO, selon le fournisseur actif de la boutique) : la
                     commande part par l'API Hermes, les clés du fournisseur
                     restent côté serveur, jamais dans le navigateur. -->
                <b-modal :ref="'bbforward'+site" :title="'Send order to ' + dsProviderLabel" size="lg" @ok="bbDoForward()" :ok-disabled="bbForwarding" :cancel-disabled="bbForwarding">
                  <!-- Loader devant le bouton d'envoi pendant l'appel au fournisseur. -->
                  <template #modal-ok>
                    <span v-if="bbForwarding" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>{{ bbForwarding ? 'Sending...' : 'Send' }}
                  </template>
                  <div v-if="bbForwarding">
                    <p class="my-4">
                      <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>Sending the order to {{ dsProviderLabel }}...
                    </p>
                  </div>
                  <div v-else>
                    <p class="my-2">
                      The order <strong>{{ bbOrder && bbOrder.transactionId }}</strong> will be sent to {{ dsProviderLabel }}
                      with the customer's delivery address and the {{ dsProviderLabel }} products of the order.
                    </p>
                    <b-form-group label="Reference sent to the provider (order reference)" label-size="sm">
                      <b-form-input v-model="bbForm.reference" size="sm"></b-form-input>
                    </b-form-group>
                    <b-form-group v-if="dsProvider === 'bigbuy'" label="Carrier (optional BigBuy carrier id)" label-size="sm">
                      <b-form-input v-model="bbForm.carrier" size="sm" placeholder="Cheapest available if empty"></b-form-input>
                    </b-form-group>
                    <b-form-checkbox v-model="bbIgnoreMissing" class="mb-2">Send only the {{ dsProviderLabel }} products (skip
                      products without a {{ dsProviderLabel }} reference)</b-form-checkbox>
                    <p v-if="bbError" class="text-danger mb-0">{{ bbError }}</p>
                    <p v-if="bbHint" class="text-muted small mb-0">{{ bbHint }}</p>
                  </div>
                </b-modal>
                <!-- Suivi du colis : statut d'expédition et numéro de suivi. -->
                <b-modal :ref="'bbtracking'+site" :title="dsProviderLabelFor(dsOrderProvider(bbOrder)) + ' tracking'" size="lg" ok-only @hide="bbTracking=null">
                  <div v-if="bbSyncing">
                    <p class="my-4">Refreshing tracking...</p>
                  </div>
                  <div v-else-if="bbTracking && bbTracking.total">
                    <p class="mb-2">Reference: <strong>{{ bbTracking.reference }}</strong></p>
                    <b-table striped hover :items="bbTracking.items" :fields="bbTrackingFields">
                      <template #cell(url)="row">
                        <a v-if="row.item.url" :href="row.item.url" target="_blank" rel="noopener">Open</a>
                        <span v-else>—</span>
                      </template>
                    </b-table>
                    <p class="text-muted small mb-0">Last sync: {{ bbTracking.lastSyncAt }}</p>
                  </div>
                  <div v-else>
                    <p class="my-4">No tracking information available yet from the provider.</p>
                  </div>
                </b-modal>
                <b-table
                  ref="TableCommande"
                  show-empty
                  striped
                  hover
                  head-variant="light"
                  bordered
                  stacked="md"
                  :items="orders"
                  :fields="tablefields"
                  :filter="filter"
                  :current-page="currentPage"
                  :per-page="perPage"
                  @filtered="onFiltered"
                >
                  <template #cell(paymentMethod)="field">
                    <div class="badge badge-glow badge-secondary">
                      {{ field.item.mode_payment }}
                    </div>
                  </template>
                  <template #cell(orderStatus)="field">
                    <div>
                      <b-form-select v-model="field.item.status" :options="OptionsOrderStatus" @change="OptionSave(field)">Order status</b-form-select>
                    </div>
                  </template>
                  <template #cell(bigbuy)="field">
                    <div>
                      <span v-if="field.item.bigbuyOrder && field.item.bigbuyOrder.forwarded" class="badge badge-glow badge-success">BigBuy</span>
                      <span v-else-if="field.item.eproloOrder && field.item.eproloOrder.forwarded" class="badge badge-glow badge-success">EPROLO</span>
                      <button
                        v-else
                        type="button"
                        class="icon-btn"
                        :disabled="bbForwarding && bbOrder === field.item"
                        :title="'Send to ' + dsProviderLabel"
                        @click="bbOpenForward(field.item)"
                      >
                        <span v-if="bbForwarding && bbOrder === field.item" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <feather v-else type="send" size="16"></feather>
                      </button>
                    </div>
                  </template>
                  <template #cell(total)="field">
                    {{ field.item.amt }}
                  </template>
                  <template #row-details="field">
                    <div class="row">
                      <div class="col-xl-4">
                        <ul style="text-align:left">
                        <li>Transaction ID : {{ field.item.transactionId }}</li>
                        <li>Firstname : {{ field.item.userDetail.firstName }}</li>
                        <li>Lastname : {{ field.item.userDetail.lastName }}</li>
                        <li>Phone : {{ field.item.userDetail.phone }}</li>
                        <li>Email : {{ field.item.userDetail.email }}</li>
                        </ul>
                      </div>
                      <div class="col-xl-4">
                        <ul style="text-align:left">
                        <li>Address : {{ field.item.userDetail.address }}</li>
                        <li>City : {{ field.item.userDetail.city }}</li>
                        <li>Postcode : {{ field.item.userDetail.postcode }}</li>
                        <li>Country : {{ field.item.userDetail.country }}</li>
                        </ul>
                      </div>
                    </div>
                    <b-table striped hover :items="field.item.products" :fields="DetailCommande">
                      <template #cell(image)="item">
                        <img
                          height="50px"
                          :src="item.item.image"
                          width="50px"
                        />
                      </template>
                      <template #cell(price)="item">
                        {{ item.item.price }} {{ field.item.symbol }}
                      </template>
                      <template #cell(total)="item">
                        {{ item.item.price * item.item.quantity }} {{ field.item.symbol }}
                      </template>
                    </b-table>
                  </template>
                  <template v-slot:cell(actions)="field">
                    <div class="row-actions">
                      <button type="button" class="icon-btn" title="View details" @click="field.toggleDetails">
                        <feather type="eye" size="16"></feather>
                      </button>
                      <button
                        v-if="(field.item.bigbuyOrder && field.item.bigbuyOrder.forwarded) || (field.item.eproloOrder && field.item.eproloOrder.forwarded)"
                        type="button"
                        class="icon-btn icon-btn-success"
                        :title="dsProviderLabelFor(dsOrderProvider(field.item)) + ' tracking'"
                        @click="bbOpenTracking(field.item)"
                      >
                        <feather type="truck" size="16"></feather>
                      </button>
                      <button type="button" class="icon-btn icon-btn-danger" title="Delete order" @click="onAlert(field.item.document)">
                        <feather type="trash-2" size="16"></feather>
                      </button>
                    </div>
                  </template>
                </b-table>
              </div>
              <b-col md="12" class="my-1 p-0 pagination-justify">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="orders.length"
                  :per-page="perPage"
                  aria-controls="my-table"
                  class="mt-4"
                ></b-pagination>
              </b-col>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from '@/utils/firestore-shim';
import axios from "axios";
import { apiUrl, uploadHeaders } from '../../../utils/imageUpload.js';
export default {
  props:["site"],
  data() {
    return {
      selectedCommandeID:null,
      orders:[],
      value: "",
      tablefields: [
        { key: "transactionId", label: "ORDER NUMBER", sortable: true },
        { key: "paymentMethod", label: "Payment Method", sortable: true },
        { key: "orderStatus", label: "Order status", sortable: true },
        { key: "bigbuy", label: "Dropshipping" },
        { key: "orderDate", label: "Date order", sortable: true },
        { key: "deliveryDate", label: "Delivery Date", sortable: true },
        { key: "total", label: "Total", sortable: true },
        { key: "actions" }
      ],
      DetailCommande: [
        { key: "image", label :"Image", sortable: true },
        { key: "title", label :"Title", sortable: true },
        { key: "VariantsSelected", label :"Variant", sortable: true },
        { key: "quantity", label :"Quantity", sortable: true },
        { key: "price", label :"Price", sortable: true },
        { key: "total", label :"Total", sortable: true }
      ],
      OptionsOrderStatus:[
        { value: 'Processing', text: 'Processing' },
        { value: 'Shipped', text: 'Shipped' },
        { value: 'Delivered', text: 'Delivered' },
        { value: 'Cancelled', text: 'Cancelled' }
      ],
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 50,
      pageOptions: [10, 50, 100, 200],
      // Dropshipping (BigBuy ou EPROLO) : envoi de commande et suivi des colis.
      // Le fournisseur est celui actif de la boutique (computed dsProvider).
      bbOrder: null,
      bbForm: { reference: "", carrier: "" },
      bbForwarding: false,
      bbError: "",
      bbHint: "",
      bbSyncing: false,
      bbTracking: null,
      bbTrackingFields: [
        { key: "status", label: "Status" },
        { key: "carrier", label: "Carrier" },
        { key: "trackingNumber", label: "Tracking number" },
        { key: "shippedDate", label: "Shipped" },
        { key: "url", label: "Link" }
      ],
      bbIgnoreMissing: false,
      bbStore: null
    };
  },
  created() {
    this.$store.dispatch("order/getOrders");
  },
  computed: {
    // Fournisseur dropshipping actif de la boutique : EPROLO en priorité s'il
    // est activé (même priorité que les frais de port au checkout), sinon
    // BigBuy. L'envoi bascule automatiquement sur l'autre fournisseur activé
    // quand la commande ne contient aucun produit du premier.
    dsProvider() {
      return this.bbStore && this.bbStore.eproloEnabled === true ? 'eprolo' : 'bigbuy';
    },
    dsProviderLabel() {
      return this.dsProvider === 'eprolo' ? 'EPROLO' : 'BigBuy';
    },
    sortOptions() {
      // Create an options list from our fields
      return this.tablefields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.orders.length;
    this.orders = this.getCommande();
    this.bbLoadStore();
  },
  methods: {
    getImgUrl(path) {
      return require("@/assets/images/dashboard/product/" + path);
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getCommande() {
      let data=[];
      let element=[];
      let ref = firebase.firestore().collection('Commandes')
      .where ("mode_payment", "!=", "")
      .where("site","in",[this.site, 'www.'+this.site])
      .get()
      .then((e) => {
        e.forEach((doc) =>{
          element = doc.data();
          element.document=doc.id;
          data.push(element);
        });
      });
      return data;
    },
    async onDelete(){
      let fs = firebase.firestore();
      await fs.collection('Commandes').doc(this.selectedCommandeID).delete().then(() => {
          this.orders = this.orders.filter((e) => e.document != this.selectedCommandeID);
          this.$refs.TableCommande.refresh();
        }).catch(function(error) {
          alert (error);
        });
        this.selectedCommandeID=null;
    },
    OptionSave(doc){
      let id = doc.item.document;
      console.log(id);
      firebase.firestore().collection('Commandes').doc(id).set(doc.item)
        .then(() => {

        })
        .catch((error) => {
          alert(error);
        });
    },
    onAlert(doc){
      console.log(doc);
      this.selectedCommandeID = doc;
      this.$refs['alertdelete'+this.site].show();
    },
    // ------------------------------------------ Dropshipping (BigBuy/EPROLO)
    // L'envoi et le suivi passent par l'API Hermes : les clés du fournisseur
    // (BigBuy ou EPROLO) restent côté serveur, jamais dans le navigateur.
    // Le serveur résout les références produits de la commande et l'adresse
    // du client, puis enregistre le résultat sur la commande (bloc
    // bigbuyOrder ou eproloOrder).
    bbOpenForward(item) {
      this.bbOrder = item;
      this.bbForm = {
        reference: item.document || "",
        carrier: ""
      };
      this.bbError = "";
      this.bbHint = "The " + this.dsProviderLabel + " products of the order are detected by their SKU / variant reference.";
      this.$refs['bbforward'+this.site].show();
    },
    async bbLoadStore() {
      try {
        var snapshot = await firebase.firestore().collection('Sites').where('host', '==', this.site).get();
        if (!snapshot.empty) this.bbStore = snapshot.docs[0].data();
      } catch (error) { /* boutique illisible : aucun fournisseur activé */ }
    },
    // Fournisseur auquel cette commande a été envoyée (badge et suivi).
    dsOrderProvider(item) {
      return item && item.eproloOrder && item.eproloOrder.forwarded ? 'eprolo' : 'bigbuy';
    },
    dsProviderLabelFor(provider) {
      return provider === 'eprolo' ? 'EPROLO' : 'BigBuy';
    },
    // Autre fournisseur activé pour la boutique : l'envoi bascule
    // automatiquement dessus quand la commande ne contient aucun produit du
    // fournisseur principal.
    dsFallbackProvider(provider) {
      if (provider === 'eprolo' && this.bbStore && this.bbStore.bigbuyEnabled === true) return 'bigbuy';
      if (provider === 'bigbuy' && this.bbStore && this.bbStore.eproloEnabled === true) return 'eprolo';
      return '';
    },
    // 422 « Aucun produit de la commande n'est un produit ... » : la commande
    // ne contient aucun produit de ce fournisseur (les autres 422, produits
    // sans référence, demandent la case ignore_missing).
    dsIsNoProductError(error) {
      if (!error || !error.response || error.response.status !== 422) return false;
      var detail = error.response.data && error.response.data.error ? String(error.response.data.error) : '';
      return detail.indexOf('Aucun produit de la commande') !== -1;
    },
    async bbDoForward() {
      var order = this.bbOrder;
      if (!order || this.bbForwarding) return;
      this.bbError = "";
      this.bbForwarding = true;
      this.$refs['bbforward'+this.site].show();
      try {
        // Fournisseur actif de la boutique, avec bascule automatique sur
        // l'autre fournisseur activé si la commande ne contient aucun de
        // ses produits.
        var sent;
        try {
          sent = await this.dsForwardTo(this.dsProvider, order);
        } catch (error) {
          var fallback = this.dsFallbackProvider(this.dsProvider);
          if (fallback && this.dsIsNoProductError(error)) {
            sent = await this.dsForwardTo(fallback, order);
          } else {
            throw error;
          }
        }
        order[sent.provider === 'eprolo' ? 'eproloOrder' : 'bigbuyOrder'] = { forwarded: true, reference: sent.reference };
        this.$refs['bbforward'+this.site].hide();
      } catch (error) {
        this.bbError = this.bbErrorMessage(error);
        this.$refs['bbforward'+this.site].show();
      } finally {
        this.bbForwarding = false;
      }
    },
    // POST /api/orders/{id}/{provider}/forward via Hermes : le serveur
    // résout les produits du fournisseur dans la commande, l'adresse du
    // client, et enregistre le bloc bigbuyOrder/eproloOrder.
    async dsForwardTo(provider, order) {
      var body = {
        reference: this.bbForm.reference || order.document,
        ignore_missing: this.bbIgnoreMissing
      };
      if (provider === 'bigbuy' && this.bbForm.carrier !== "") body.carrier = this.bbForm.carrier;
      var res = await axios.post(
        apiUrl + '/api/orders/' + encodeURIComponent(order.document) + '/' + provider + '/forward',
        body,
        { headers: uploadHeaders(), timeout: 45000 }
      );
      var data = res.data || {};
      return { provider: data.provider || provider, reference: data.reference || body.reference };
    },
    // Suivi du colis via Hermes : GET /api/orders/{id}/{provider}/tracking.
    // Le serveur interroge le fournisseur (BigBuy ou EPROLO) et enregistre
    // le suivi sur la commande ; en cas d'échec réseau, le dernier suivi
    // connu reste affiché.
    async bbOpenTracking(item) {
      var provider = this.dsOrderProvider(item);
      var block = (provider === 'eprolo' ? item.eproloOrder : item.bigbuyOrder) || {};
      if (!block.forwarded) return;
      this.bbOrder = item;
      this.bbSyncing = true;
      this.$refs['bbtracking'+this.site].show();
      try {
        var res = await axios.get(
          apiUrl + '/api/orders/' + encodeURIComponent(item.document) + '/' + provider + '/tracking',
          { headers: uploadHeaders(), timeout: 30000 }
        );
        var data = res.data || {};
        var items = Array.isArray(data.items) ? data.items : [];
        this.bbTracking = {
          reference: data.reference || block.reference,
          lastSyncAt: data.lastSyncAt || '',
          total: data.total !== undefined ? data.total : items.length,
          items: items
        };
      } catch (error) {
        var cached = Array.isArray(block.tracking) ? block.tracking : [];
        this.bbTracking = { reference: block.reference, lastSyncAt: block.lastSyncAt || '', total: cached.length, items: cached };
      } finally {
        this.bbSyncing = false;
      }
    },
    // Les erreurs Hermes arrivent dans error.response.data.error (messages
    // du serveur : fournisseur désactivé, aucun produit, déjà envoyée...).
    bbErrorMessage(error) {
      var detail = error && error.response && error.response.data && error.response.data.error
        ? String(error.response.data.error) : '';
      var status = error && error.response ? error.response.status : 0;
      if (!status) return "Unable to reach the Hermes API (" + ((error && error.message) || "network error") + ").";
      if (status === 401) return detail || "Hermes API key invalid or missing (x-api-key). Check config.json.";
      if (status === 404) return detail || "Order not found on the Hermes API.";
      if (status === 409) return detail || "The order was already sent, or the provider is disabled for this store.";
      if (status === 422) return detail || "No product of this order belongs to the provider.";
      if (status === 502 || status === 504) return detail || "The provider returned an error or did not answer in time.";
      return detail || "Hermes API returned HTTP " + status + ".";
    }
  }
};
</script>

<style>

</style>